import React from 'react';
import Reminder from '../Reminder/Reminder';
import ICollaboratorProps, { TCollaboratorState } from './ICollaborator';

import * as style from './CollaboratorStyles.module.scss'

export default class Collaborator extends React.Component<ICollaboratorProps, TCollaboratorState> {
  sentInfo = 'Invitation sent';
  timeout: any = null;

  state: TCollaboratorState = {
    invitationSent: false,
    btnInfo: this.sentInfo,
    showInfo: false,
  };

  deleteCollaborator = () => {
    this.props.deleteCollaborator(this.props.id);
  }

  sendInvitation = (success: boolean, message = '') => {
    if (success) {
      this.setState({ invitationSent: true, showInfo: true });
    } else if (message) {
      clearTimeout(this.timeout);
      this.setState({ invitationSent: true, btnInfo: message, showInfo: true });

      setTimeout(() => {
        this.setState({ btnInfo: this.sentInfo, showInfo: false });
      }, 1000);
      this.timeout = setTimeout(() => {
        this.setState({ invitationSent: false });
      }, 6000);
    }
  }

  render() {
    return (
      <div className={style.collaborator}>
        <div className={style.collaborator_img}>
          <img src={this.props.avatar} alt="user image"/>
        </div>
        <div className={style.collaborator_data}>
          <div className={style.collaborator_data_nameholder}>
            <h3 className={style.collaborator_name}>{this.props.name}</h3>
          </div>
          <div className={style.collaborator_data_btnholder}>
            <button onClick={this.deleteCollaborator}><span className="fa fa-times"/></button>
          </div>
          {!this.props.verified &&
            <React.Fragment>
              <p className={style.collaborator_info}>Awaiting confirmation</p>
              <Reminder
                callbackClick={this.sendInvitation}
                text={this.state.showInfo ? this.state.btnInfo : 'Resend invitation'}
                path={`/api/companies/${this.props.companyId}/collaborators/${this.props.id}/invitation`}
                block={this.state.invitationSent}
              />
            </React.Fragment>
          }
        </div>
      </div>
    );
  }
}
